/**
 * Email Template-specific translation keys
 */
export const emailTemplate = {
  list: {
    search_placeholder: "admin.email_template_search_placeholder",
    main_heading: "admin.email_template_list_heading",
    no_permission_to_view: "admin.email_template_no_permission_to_view",
    table: {
      created_at_table_col_heading: "admin.email_template_created_at_table_col_heading",
      subject_table_col_heading: "admin.email_template_subject_table_col_heading",
      title_table_col_heading: "admin.email_template_title_table_col_heading",
      action_table_col_heading: "admin.email_template_action_table_col_heading",
    },
    create_email_template_btn_text: "admin.email_template_create_btn_text",
    delete_popup_heading_text: "admin.email_template_delete_popup_heading_text",
    delete_popup_yes_btn_text: "admin.email_template_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.email_template_delete_popup_no_btn_text",
    clear_filter_btn_text: "admin.email_template_clear_filter_btn_text",
  },
  add: {
    main_heading: "admin.email_template_add_heading",
    slug_label: "admin.email_template_slug_label",
    slug_placeholder: "admin.email_template_slug_placeholder",
    parameter_label: "admin.email_template_parameter_label",
    parameter_label_placeholder: "admin.email_template_parameter_placeholder",
    title_label: "admin.email_template_title_label",
    title_placeholder: "admin.email_template_title_placeholder",
    subject_label: "admin.email_template_subject_label",
    subject_placeholder: "admin.email_template_subject_placeholder",
    content_label: "admin.email_template_content_label",
    content_placeholder: "admin.email_template_content_placeholder",
    submit_btn_text: "admin.email_template_submit_btn_text",
    cancel_btn_text: "admin.email_template_cancel_btn_text",
    loading_btn_text: "admin.email_template_loading_btn_text",
    update_btn_text: "admin.email_template_update_btn_text",
  },
  edit: {
    main_heading: "admin.email_template_edit_heading",
  },
  form: {
    slug_label: "admin.email_template_slug_label",
    slug_placeholder: "admin.email_template_slug_placeholder",
    parameter_label: "admin.email_template_parameter_label",
    parameter_label_placeholder: "admin.email_template_parameter_placeholder",
    title_label: "admin.email_template_title_label",
    title_placeholder: "admin.email_template_title_placeholder",
    subject_label: "admin.email_template_subject_label",
    subject_placeholder: "admin.email_template_subject_placeholder",
    content_label: "admin.email_template_content_label",
    content_placeholder: "admin.email_template_content_placeholder",
    submit_btn_text: "admin.email_template_submit_btn_text",
    cancel_btn_text: "admin.email_template_cancel_btn_text",
    loading_btn_text: "admin.email_template_loading_btn_text",
    update_btn_text: "admin.email_template_update_btn_text",
  },
};
